/**
 * CSV Export Utility
 * Provides functionality to export data to CSV format
 */

import Papa from 'papaparse';

/**
 * Export data to CSV file and trigger download
 * @param {Array} data - Array of data objects to export
 * @param {string} filename - Name of the file (without extension)
 * @param {Array} columns - Array of column definitions with { label, accessor }
 *                          accessor can be a function or a string path
 */
export const exportToCSV = (data, filename, columns) => {
  // Transform data using column accessors
  const transformedData = data.map(row => {
    const transformedRow = {};
    columns.forEach(column => {
      const value = typeof column.accessor === 'function' 
        ? column.accessor(row) 
        : getNestedValue(row, column.accessor);
      transformedRow[column.label] = value !== null && value !== undefined ? value : '';
    });
    return transformedRow;
  });

  // Generate CSV using PapaParse
  const csv = Papa.unparse(transformedData, {
    quotes: true,
    delimiter: ';',
    header: true,
    newline: '\n'
  });

  // Add BOM for proper Excel UTF-8 encoding
  const BOM = '\uFEFF';
  const csvWithBOM = BOM + csv;

  // Create blob and download
  const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  
  // Generate filename with timestamp
  const timestamp = new Date().toISOString().split('T')[0];
  link.download = `${filename}_${timestamp}.csv`;
  
  document.body.appendChild(link);
  link.click();
  
  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

/**
 * Helper function to get nested object value by path
 * @param {Object} obj - Source object
 * @param {string} path - Dot-notated path (e.g., 'user.name')
 * @returns {*} - Value at path or undefined
 */
const getNestedValue = (obj, path) => {
  if (typeof path !== 'string') return obj[path];
  
  return path.split('.').reduce((current, key) => {
    return current?.[key];
  }, obj);
};
